import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import FileImport from '../components/FileImport.js';
import trans from "../util/trans";
import Notify from "../components/Notify";


export default class GuidesView extends BaseView {
    constructor() {
        super();
        this.modalClasses = 'larger-modal allow-enter';
        this.formSelector = '#guideForm';
        this.formUrl = '/api/guides';
        this.formTpl = 'guide-form';
        this.formTitle = Lang.guideInforTitle;
        this.defaultObject = {
            title: '',
            desc: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();
        const self = this;

        if ($('#guides').length > 0) {
            const columns = [
                {data: 'select', orderable: false},
                {data: 'order'},
                {data: 'title'},
                {data: 'desc'},
                {data: 'hidden'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'creator'},
                {data: 'roles', orderable: false}, // index 9
                {data: 'tools', orderable: false},
            ];

            if ($('#guides.blessed').length > 0) {
                columns[9] = {data: 'prolific', orderable: false};
            }

            this.table = new Table('guides', '/api/guides/table', columns);

            this.menu = new Dropdown('#guidesPageMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletex', ids.length),
                            onConfirm: function () {
                                // Guides.api.del(ids);
                                // TODO: delete multiple intead of loop below
                                $.each(ids, function (i, row) {
                                    Api.send(`/api/guides/${row}`, {}, 'delete').done(function () {
                                        self.table.reload();
                                    });
                                });
                            }
                        });
                    }
                },
                onExport: function (ids) {
                    const app = $('[data-app]').data('app');
                    window.location = `/api/guides/export?app=${app}&ids=${ids}`;
                },
                onExportPDF: function (ids) {
                    const app = $('[data-app]').data('app');
                    window.location = `/api/guides/pdfexport?app=${app}&ids=${ids}`;
                },
                onExportExcel: function (ids) {
                    const app = $('[data-app]').data('app');
                    window.location = `/api/guides/excelexport?app=${app}&ids=${ids}`;
                },
                onClone: function (ids) {
                    $.each(ids, function (i, row) {
                        Api.send(`/api/guides/${row}/clone`, {}, 'post').done(function () {
                            self.table.reload();
                        });
                    });
                },
                onAssign: function (ids) {
                    if (ids.length > 0) {
                        // repurpose roleuser-form
                        Api.getTpl('roleuser-form').done(r => {
                            Api.send('/api/users', {org: $('[data-org]').data('org')}).done(function (users) {
                                const tpl = _.template(r);
                                Confirm({
                                    ok: Lang.save,
                                    title: Lang.guideAssingUsers,
                                    msg: tpl({users: users}),
                                    onConfirm: () => {
                                        const data = $('form').aeroSerialize();
                                        Api.send('/api/users/assign', {guides: ids, users: data.userid}, 'post').done(() => {
                                            Notify(Lang.success, 'success', 600);
                                        });
                                    }
                                });
                            });
                        });
                    }
                },
                onFind: function (ids) {
                    self.renderReplaceForm(ids);
                    return false;
                },
                onEdit: function (ids) {
                    if (ids.length > 0) {
                        Api.getTpl('guide-active-form').done(function (r) {
                            const tpl = _.template(r);

                            Confirm({
                                ok: Lang.save,
                                title: Lang.activatedeactivate,
                                msg: tpl(),
                                onConfirm: function () {
                                    const data = $('#guideActive').aeroSerialize();
                                    data.active = !!(data.active);
                                    data.locked = !!(data.locked);
                                    data.toggleComplete = !!(data.toggleComplete);
                                    $.each(ids, function (i, row) {
                                        Api.send(`/api/guides/${row}`, data, 'patch').done(function () {
                                            if (i === ids.length - 1) {
                                                self.table.reload();
                                            }
                                        });
                                    });
                                }
                            });
                        });
                    }
                }
            });

            const fileImport = new FileImport($('#import'), {
                url: '/api/guides/import',
                formTpl: 'import-file-form',
                title: Lang.guide,
                datalist: self.table
            });
            fileImport.init();

            const fortressiq = new FileImport($('#fortressiq'), {
                url: '/api/guides/fortressiq',
                formTpl: 'fortressiq-form',
                title: Lang.fortrssIqImport,
                datalist: self.table
            });
            fortressiq.init();
        }

        if ($('#enterpriseGuides').length > 0) {
            this.entTable = new Table('enterpriseGuides', '/api/guides/enterprisetable', [
                {data: 'title', orderable: true},
                {data: 'desc'},
                {data: 'hidden'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'roles'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    getFormData() {
        const data = super.getFormData();
        data.active = !!(data.active);
        data.auto = !!(data.auto);
        data.locked = !!(data.locked);
        data.hidden = !!(data.hidden);
        data.autoPage = !!(data.autoPage);
        data.desc = $('#guideEditor').trumbowyg('html');
        // it's a bit cheeky, but only set these if we're blessed
        if ($('#guides.blessed').length > 0) {
            data.allowHide = !!data.allowHide;
            data.prolific = !!data.prolific;
        }
        return data;
    }

    renderReplaceForm(ids) {
        const self = this;
        let method, url;

        method = 'patch';
        url = `/api/guides/`;

        Api.getTpl('guide-find-replace').done(function (r) {
            const tpl = _.template(r);
            let data = {ids: ids, case: false};
            Confirm({
                ok: Lang.save,
                title: Lang.afindr,
                msg: tpl({data: data}),
                onValidate: function () {
                    return $('#guide-find-form').isFormValid();
                },
                onConfirm: function () {
                    const formData = $('#guide-find-form').aeroSerialize();
                    formData.case = !!(formData.case);
                    $.each(ids, function (i, row) {
                        Api.send(url + row + '/replace', formData, method).done(function () {
                            self.table.reload();
                        });
                    });
                }
            });
        });
    }

    reorderGuides() {
        const self = this;
        Api.send('/api/guides').done(function (g) {
            Api.getTpl('reorder-form').done(function (r) {
                const tpl = _.template(r);

                Confirm({
                    ok: Lang.save,
                    title: Lang.guides,
                    msg: tpl({items: g}),
                    classes: 'large-modal',
                    onConfirm: function () {
                        const data = {guides: []};
                        $('#reorderForm input').each(function () {
                            data.guides.push($(this).val());
                        });
                        Api.send('/api/guides/reorder', data, 'post').done(function () {
                            self.table.reload();
                        });

                    }
                });
            });
        });
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#guideGroup');
        const body = $('body');

        $('#guides table').on('draw.dt', function () {
            self.guideButtonCheck();
        });

        //Add
        section.parents('main').find('.add').off("click.patha").on("click.patha", function () {
            if ($(this).hasClass('disabled')) {
                return false;
            }
            Api.send(`/api/tags`).done(function (r) {
                self.renderForm(r,'allowed');
            });
            return false;
        });

        //Delete
        section.off("click.guided").on("click.guided", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/guides/${id}`, {}, 'delete').done(function () {
                        self.guideButtonCheck();
                        self.table.reload();
                    });
                }
            });
            return false;
        });

        //Edit
        section.off("click.guidee").on("click.guidee", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            Api.send(`/api/tags`).done(function (r) {
                let tags = r;
                Api.send(`/api/guides/${id}`).done(function (r) {
                    const selectedTags = r?.tags && r?.tags.map((tag)=>tag.name);
                    r['selectedTags'] = selectedTags;
                    r['tags'] = tags;
                    self.renderForm(r);
                });
            });
            
            return false;
        });

        $('.reorder-guides').on('click', function () {
            self.reorderGuides();
            return false;
        });

        // works for guides and pathway reorders
        body.on('click', '#reorderForm .sort-alpha', function () {
            const items = $('.ui-sortable li');
            const asc = (a, b) => $(a).find('.title').text().localeCompare($(b).find('.title').text(), 'en', {numeric: true});
            const desc = (a, b) => $(b).find('.title').text().localeCompare($(a).find('.title').text(), 'en', {numeric: true});
            items.sort($(this).hasClass('asc') ? asc : desc);
            $('.ui-sortable').empty().append(items).sortable('refresh');
            $(this).toggleClass('asc');
            return false;
        });

        body.on('click', '#reorderForm .sort-date', function () {
            const items = $('.ui-sortable li');
            const asc = (a, b) => $(a).data('date').localeCompare($(b).data('date'), 'en', {numeric: true});
            const desc = (a, b) => $(b).data('date').localeCompare($(a).data('date'), 'en', {numeric: true});
            items.sort($(this).hasClass('asc') ? asc : desc);
            $('.ui-sortable').empty().append(items).sortable('refresh');
            $(this).toggleClass('asc');
            return false;
        });

        // Copy Down
        $('#enterpriseGuides').off("click.guidecp").on("click.guidecp", ".clone", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/guides/${id}/copydown`, {}, 'post').done(function () {
                $('[href="#panel1"]').trigger('click');
                self.table.reload();
            });
            return false;
        });

        //Find Preview -- not being used?
        section.off("click.grepl").on("click.grepl", ".aero-btn-fpreview", function () {
            if ($('#findReplaceForm').isFormValid()) {
                // Guide.model.replaceProp($(this).parents('form').data('ids'), true);
                // TODO: Find preview?
            }
        });

        body.on('change.autoack', 'select[name="autoAck"]', function () {
            const val = $('select[name="autoAck"]').val();
            if (val == 'all' || val == 'suspend') {
                $('.aero-auto-behavior').show();
                $('.aero-always-behavior').hide();
            } else if (val == 'always') {
                $('.aero-auto-behavior').hide();
                $('.aero-always-behavior').show();
            } else {
                $('.aero-auto-behavior').hide();
                $('.aero-always-behavior').hide();
            }
        });

        body.on('change.launchack', 'select[name="launchAck"]', function () {
            const val = $('select[name="launchAck"]').val();
            if (val == '' || val == 'dismiss') {
                $('.aero-launch-behavior').hide();
            } else {
                $('.aero-launch-behavior').show();
            }
        });
    }

    guideButtonCheck() {
        const limit = parseInt($('.add').data('limit'));
        const guideCount = $('#guides tbody tr td:not(.dataTables_empty)').length;

        if (guideCount >= limit) {
            $('.add').addClass('disabled').attr('title', Lang.limitbreak);
        } else {
            $('.add').removeClass('disabled').attr('title', '');
        }
    }
}
